module.exports = __webpack_public_path__ + "static/025.thumb-007568bebb70b4c833dc764f8fa1c9e1.jpg";